<template>
    <section>
        Aqui
    </section>
</template>

<script>

export default {
  name: "sale-recovery",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

</style>
